(() => {
  const money = cents => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.spratlyThemeSettings?.money_format);
    }
    return new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', maximumFractionDigits: 0 }).format(cents / 100);
  };

  function initKit(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.closest('form[action*="/cart/add"]');
    if (!form) return;

    const basePrice = Number(root.dataset.basePrice || 0);
    const totalNode = root.querySelector('[data-kit-total]');
    const extrasNode = root.querySelector('[data-kit-extras-total]');
    const statusNode = root.querySelector('[data-kit-status]');
    const submit = form.querySelector('[name="add"]');

    const update = () => {
      root.querySelectorAll('[data-kit-group]').forEach(group => {
        const selected = group.querySelector('input[type="radio"]:checked');
        const property = root.querySelector(`[data-kit-property="${group.dataset.kitGroup}"]`);
        if (selected && property) property.value = selected.value;
      });

      const extras = [...root.querySelectorAll('[data-extra-price]:checked')];
      const extraTotal = extras.reduce((sum, input) => sum + Number(input.dataset.extraPrice || 0), 0);
      totalNode.textContent = money(basePrice + extraTotal);
      extrasNode.hidden = extraTotal === 0;
      extrasNode.querySelector('b').textContent = `+${money(extraTotal)}`;
      statusNode.textContent = extras.length
        ? `נבחרו ${extras.length} תוספות. המחיר עודכן בסיכום.`
        : 'המארז מוכן — אפשר להוסיף לסל';
    };

    root.addEventListener('change', update);
    update();

    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.kitAdding === 'true') return;

      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });

      const selectedExtras = [...root.querySelectorAll('[data-extra-price]:checked')];
      const extraNames = selectedExtras.map(input => input.dataset.extraName);
      if (extraNames.length) properties['תוספות שנבחרו'] = extraNames.join(', ');

      const items = [{ id: Number(variantId), quantity, properties }];
      selectedExtras.forEach(input => {
        items.push({
          id: Number(input.value),
          quantity,
          properties: { 'נוסף למארז': productLabel(), '_מזהה מארז': variantId }
        });
      });

      form.dataset.kitAdding = 'true';
      form.classList.add('adding');
      submit?.setAttribute('aria-busy', 'true');
      statusNode.textContent = 'מוסיפים את המארז לסל…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'לא הצלחנו להוסיף את המארז לסל');

        statusNode.textContent = 'המארז נוסף לסל בהצלחה';
        if (window.Shopify?.onItemAdded && data.items?.length) {
          const [first, ...rest] = data.items;
          window.Shopify.onItemAdded(first);
          rest.forEach(item => window.Shopify.onItemAdded(item, false));
        } else {
          window.location.assign('/cart');
        }
      } catch (error) {
        statusNode.textContent = error.message || 'אירעה שגיאה. נסה שוב.';
        statusNode.style.color = '#a12626';
      } finally {
        form.dataset.kitAdding = 'false';
        form.classList.remove('adding');
        submit?.removeAttribute('aria-busy');
      }
    }, true);

    function productLabel() {
      return document.querySelector('.prod__title h1')?.textContent.trim() || 'מארז זקן מותאם אישית';
    }
  }

  const initAll = context => context.querySelectorAll('[data-shf-kit]').forEach(initKit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
